<div class="col th-p chats content">
  <div class="contents">
    <div class="scroll-bar">
      <div class="content-wrapper  is-clearfix">
        <div class="column chat-name cus-cards">
          <img [src]="'../../../assets/images/slack-icon-10.png'" class="is-pulled-left">
          <h3 class="is-marginless is-clearfix"> Slack Connection</h3>
        </div>

        <div class="column ">

          <div class="columns">
            <div class="column is-half is-offset-one-quarter">

              <div class="card">
                <div class="card-content">
                  <div class="">

                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label">Name</label>
                      </div>
                      <div class="field-body">
                        <div class="field">
                          <div class="control">
                            <input class="input" type="text" placeholder="">
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- field -->
                    <div class="field is-horizontal">
                      <div class="field-label">
                        <label class="label">Status</label>
                      </div>
                      <div class="field-body">
                        <div class="field is-narrow">
                          <div class="control">
                            <label class="radio">
                              <input type="radio" name="member"> Enabled
                            </label>
                            <label class="radio">
                              <input type="radio" name="member"> Disabled
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- field -->
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label">URL</label>
                      </div>
                      <div class="field-body">
                        <div class="field">
                          <div class="control">
                            <input class="input" type="text" placeholder="">
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- field -->
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label">Description</label>
                      </div>
                      <div class="field-body">
                        <div class="field">
                          <div class="control">
                            <input class="input" type="text" placeholder="">
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- field -->

                    <div class="field is-horizontal">
                      <div class="field-label">
                        <!-- Left empty for spacing -->
                      </div>
                      <div class="field-body">
                        <div class="field">
                          <div class="control">
                            <button class="button is-link">Update</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- field -->
                  </div>

                </div>
              </div>
              <!-- card -->
            </div>
          </div>
        </div>

      </div>
      <!-- content wrapper ends -->
    </div>
  </div>
</div>
